import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { tradeOrderTypeAtom } from '@root/features/trade/trading'

import { TradingControlsQuote } from '../trading-controls-quote/trading-controls-quote'

import type { BuyControlsModel } from '../../../atoms/common'
import type { Pair } from '@root/entities/pair'

type Props = {
  pair: Pair.PairMinimal
  model: BuyControlsModel
}

export const TradingControlsBuyQuote: React.FC<Props> = ({ model, pair }) => {
  const [tradeOrderType] = useAtom(tradeOrderTypeAtom)

  const [amountNative] = useAtom(model.amountInputModel.amountAtom)
  const [limitReceiveAmount] = useAtom(model.limitModel.receiveAtom)
  const [quoteState_] = useAtom(model.quoteModel.quoteStateAtom)

  const quoteState = useMemo(() => {
    if (tradeOrderType === 'limit') {
      return AsyncStateN.success({
        inputAmount: amountNative,
        outputAmount: limitReceiveAmount,
      })
    }
    return quoteState_
  }, [tradeOrderType, quoteState_, amountNative, limitReceiveAmount])

  if (amountNative.isZero()) {
    return undefined
  }

  return <QuoteStyled quoteState={quoteState} swapDirection="buy" pair={pair} />
}

const QuoteStyled = styled(TradingControlsQuote)`
  place-content: end;
  padding-bottom: 10px;
  min-height: 24px;
  margin-inline: 10px;
`
